import { create } from 'zustand'

import type { QueryStore } from '@models/Query'

import { initialState } from '../services/searchActiviteiten'
import type { ActiviteitenSearch } from '../types/ActiviteitenSearch'

export { useActiviteitenSearchStore }

const useActiviteitenSearchStore = () => {
  const query = useStore((state) => state.query)
  const storeQuery = useStore((state) => state.storeQuery)

  return { query, storeQuery }
}

const useStore = create<QueryStore<ActiviteitenSearch['query']>>((set) => ({
  query: initialState.query,
  storeQuery: (query) =>
    set((state) => ({ query: { ...state.query, ...query } })),
}))
